export default "__VITE_ASSET__Ssl3yKK9__"